import React, { Fragment } from 'react';
import { Icon, Block } from 'framework7-react';
import II18 from '../translate/II18';
import { gaPageView } from '../helpers/Analytics';
import PropTypes from 'prop-types';
import EnterEmailForm from './EnterEmailForm';
import { connect } from 'react-redux';
import CustomFormMerkur from './CustomFormMerkur';

class ThankyouContent extends React.Component {
  componentDidMount() {
    gaPageView('Thankyou');
  }

  onSend() {
    if (
      !this.userEmail.checkValidity() ||
      !this.userPass.checkValidity() ||
      !this.userAGB.checkValidity()
    ) {
      this.$f7.dialog.alert(
        II18.get('dialog_fill_all_fields'),
        II18.get('dialog_attention')
      );
    }
  }

  render = () => {
    const { inPersonChannel, postalChannel } = this.props;
    const requestEmailAfterComplete = inPersonChannel || postalChannel;
    return (
      <Fragment>
        <Block
          style={{
            marginBottom: 10
          }}
        >
          <p
            id={'thankyou_is_done'}
            style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 16 }}
          >
            <II18>thankyou_is_done</II18>
          </p>
          <p style={{ textAlign: 'center', color: '#999' }}>
            {this.props.recipientRequestId === 'demo' ? (
              <span>Das war unser Demo-Modus</span>
            ) : (
              <span>
                <II18 params={this.props.companyName}>
                  thankyou_receive_your_documents
                </II18>
              </span>
            )}
          </p>
        </Block>
        <Block
          className="text-align-center"
          style={{ marginTop: 10, marginBottom: 10 }}
        >
          <Icon material="done_all" color="#0B7BE9" size="65" />
        </Block>

        {requestEmailAfterComplete ? (
          postalChannel && this.props.customizationKey === 'merkur' ? (
            <CustomFormMerkur
              recipientRequestId={this.props.recipientRequestId}
            />
          ) : (
            <EnterEmailForm
              recipientRequestId={this.props.recipientRequestId}
            />
          )
        ) : (
          <Block style={{ textAlign: 'center' }}>
            <II18>thankyou_you_may_close</II18>
          </Block>
        )}

        {/*
        <Row>
          <Col width="20" />
          <Col width="60">
            <hr />
          </Col>
          <Col width="20" />
        </Row>

        <Block style={{ marginTop: 10, marginBottom: 10 }}>
          <Row>
            <Col>
              <p className="text-align-center">
                Möchten Sie die Dokumente für später speichern?
              </p>
            </Col>
          </Row>
          <div style={{ maxWidth: 400, margin: '0 auto' }}>
            <Row
              style={{
                backgroundColor: window.isDesktop ? '#889cb2' : '#0B7BE9',
                color: 'white',
                paddingTop: 10,
                paddingBottom: 10,
                borderBottom: '1px solid white'
              }}
              noGap
            >
              <Col width="20" className="text-align-center">
                <Icon material="account_box" size="39" />
              </Col>
              <Col width="70">Erstellen Sie einfach ein Equinox-Konto</Col>
              <Col width="10">
                <Icon material="info" />
              </Col>
            </Row>
            <Row
              style={{
                backgroundColor: window.isDesktop ? '#889cb2' : '#0B7BE9',
                color: 'white'
              }}
            >
              <Col style={{ padding: 15 }}>
                <Row>
                  <Col>
                    <input
                      ref={el => {
                        this.userEmail = el;
                      }}
                      type="email"
                      required
                      validate
                      placeholder="Email"
                      style={inputStyle}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <input
                      ref={el => {
                        this.userPass = el;
                      }}
                      type="password"
                      required
                      validate
                      placeholder="Password"
                      style={inputStyle}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <input
                      type="checkbox"
                      ref={el => {
                        this.userAGB = el;
                      }}
                      required
                    />{' '}
                    <label>Ich stimme den Equinox-AGB zu</label>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="padding-top">
              <Col style={{ justifyContent: 'center', display: 'flex' }}>
                <Button
                  onClick={() => this.onSend()}
                  fill
                  large
                  color="green"
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    background: '#6ACA6B',
                    lineHeight: '35px',
                    height: 35
                  }}
                >
                  Kostenloses Konto erstellen
                </Button>
              </Col>
            </Row>
          </div>
        </Block>
        */}
      </Fragment>
    );
  };
}

ThankyouContent.propTypes = {
  recipientRequestId: PropTypes.string,
  companyName: PropTypes.string,
  customizationKey: PropTypes.string,
  inPersonChannel: PropTypes.bool,
  postalChannel: PropTypes.bool
};

const mapStateToProps = state => ({
  inPersonChannel: state.inPersonChannel,
  postalChannel: state.postalChannel,
  customizationKey: state.customizationKey,
  recipientRequestId: state.recipientRequestId,
  companyName: state.companyName
});

export default connect(mapStateToProps)(ThankyouContent);
